import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, Router, withComponentInputBinding } from '@angular/router';
import { GlobalErrorHandler, httpErrorInterceptor } from '@saexpeditions/sdk/errors';
import { authInterceptor, AUTH_SESSION_HANDLER } from '@saexpeditions/sdk/authentication';
import { API_BASE_URL } from '@saexpeditions/sdk/data';
import { routes } from './app.routes';

import { TokenSessionService } from '@core/services';
import { environment } from '@environments/environment';
import {
  provideRokitIcons,
  LUCIDE_ICONS,
  CUSTOM_ICONS,
  HEROICONS_ICONS,
  IONICONS_ICONS,
} from '@saexpeditions/sdk/web/icons';
import { provideLoader } from '@saexpeditions/sdk/web/loader';

// --- SSO (comentado - reemplazado por autenticación API REST) ---
// import { AuthSessionService } from '@core/services';
// import { CookieSessionAuthService, type SSOConfig } from '@saexpeditions/sdk/sso';
// import { initializeApp } from 'firebase/app';
// import { getAuth, signInWithCustomToken } from 'firebase/auth';
// initializeApp(environment.firebase);
//
// function initializeAuthSession() {
//   return () => {
//     const authSessionService = inject(AuthSessionService);
//     return authSessionService.initialize();
//   };
// }
//
// function initializeSSO() {
//   return () => {
//     const cookieAuthService = inject(CookieSessionAuthService);
//     const ssoConfig = (environment as any).sso as SSOConfig | undefined;
//     if (ssoConfig) {
//       cookieAuthService.configure((token) => signInWithCustomToken(getAuth(), token), ssoConfig);
//     }
//   };
// }


export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: API_BASE_URL, useValue: environment.apiUrl },
    {
      provide: AUTH_SESSION_HANDLER,
      useFactory: () => {
        const tokenSession = inject(TokenSessionService);
        const router = inject(Router);
        return {
          onSessionExpired: () => {
            tokenSession.clearSession();
            router.navigate(['/login']);
          },
        };
      },
    },
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([httpErrorInterceptor, authInterceptor])),
    provideRokitIcons({
      icons: { ...LUCIDE_ICONS, ...HEROICONS_ICONS, ...IONICONS_ICONS, ...CUSTOM_ICONS },
    }),
    provideLoader({
      spinnerImage: 'assets/images/loader/rokit-circle.png',
    }),
    provideAppInitializer(() => {
      const tokenSession = inject(TokenSessionService);
      return tokenSession.initialize();
    }),
    // --- SSO (comentado) ---
    // provideAppInitializer(() => {
    //   const authSession = inject(AuthSessionService);
    //   return authSession.initialize();
    // }),
    // provideAppInitializer(() => {
    //   const cookieAuthService = inject(CookieSessionAuthService);
    //   const ssoConfig = (environment as any).sso as SSOConfig | undefined;
    //   if (ssoConfig) {
    //     cookieAuthService.configure((token) => signInWithCustomToken(getAuth(), token), ssoConfig);
    //   }
    // }),
  ],
};
